import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";

const STORAGE_KEY = "paperbrainz_cookie_notice_v1";

function CookieNotice() {
  const { theme } = useTheme();
  const d = theme === "dark";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      // localStorage may be blocked — fail silently, show notice
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: Date.now() }));
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie notice"
      className={`fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:bottom-6 sm:max-w-md z-[60] rounded-[16px] border backdrop-blur-xl shadow-lg p-5 transition-colors duration-300 ${
        d
          ? "bg-black/80 border-white/[0.08] text-gray-300"
          : "bg-white/95 border-gray-200 text-gray-700"
      }`}
    >
      <p className={`text-sm font-medium mb-1 ${d ? "text-white" : "text-gray-900"}`}>
        We use essential cookies
      </p>
      <p className="text-sm font-light leading-relaxed mb-4">
        We use cookies only to keep you signed in and remember your preferences (theme,
        this dialog). We do not use tracking or advertising cookies. See our{" "}
        <Link
          to="/cookie-policy"
          className={`underline underline-offset-2 ${d ? "text-white hover:text-gray-300" : "text-gray-900 hover:text-gray-600"}`}
        >
          Cookie Policy
        </Link>
        .
      </p>
      <div className="flex items-center justify-end">
        <button
          onClick={dismiss}
          className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${
            d ? "bg-white text-black hover:bg-gray-200" : "bg-gray-900 text-white hover:bg-black"
          }`}
        >
          Got it
        </button>
      </div>
    </div>
  );
}

export default CookieNotice;
